/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import SearchBar from '../../components/search-bar'

const Testing = ({ className = "" }) => {

  return (
    <div className={`background-dark p-0 relative vh-100 z-index-20 ${className}`} style={{width: '100%', maxWidth: '1920px'}}>
      <SearchBar />
    </div>
  )
}

export default React.memo(Testing)
